// extracted by mini-css-extract-plugin
export default {"root":"mw21TKQX","backButton":"s2KTfv2v","backIcon":"E3bzJgi9","title":"vrSD7J71","menuButton":"v4avQQ0R"};